module.exports = "../images/fishing-lodge-03.jpg?v=6d3e2ce";